import { get, keyBy } from 'lodash';

import {
    AGENT_REORDER,
    AGENT_UPDATE,
    FETCH_BAS_AGENTS,
    FETCH_BAS_AGENTS_REPORT,
    SET_AGENT,
    SET_SELECTED_AGENT
} from '../actions/actionTypes';

const initialState = {
    basAgents:       {},
    order:           'asc',
    orderBy:         'name',
    selectedAgent:   {},
    selectedAgentId: null,
    updatedAt:       null
};

export default (state = initialState, action) => {
    if (action.type === AGENT_UPDATE) {
        const current = state.basAgents[action.payload.id];
        if (current) {
            action.payload.sensorCount = current.sensorCount;
            action.payload.site = current.site;
        } 
    }

    switch (action.type) {
        case AGENT_REORDER:
            return {
                ...state,
                ...action.payload
            };
        case AGENT_UPDATE:
            return {
                ...state,
                basAgents: {
                    ...state.basAgents,
                    [action.payload.id]: action.payload
                },
                updatedAt: new Date()
            };
        case FETCH_BAS_AGENTS:
            return {
                ...state,
                basAgents: keyBy(action.payload, 'id'),
                updatedAt: new Date()
            };
        case FETCH_BAS_AGENTS_REPORT:
            return {
                ...state,
                basAgentsReport: action.payload
            };
        case SET_AGENT:
            return {
                ...state,
                selectedAgentId: get(action, 'payload.id', null)
            };
        case SET_SELECTED_AGENT:
            return {
                ...state,
                selectedAgent:   { ...action.payload },
                selectedAgentId: get(action, 'payload.id', null)
            };
        default:
            return state;
    }
};
